import { UAParser } from 'ua-parser-js'

class Agent {
  constructor (name, version = '0') {
    const a = new UAParser().getResult()
    this._v = {
      app: {
        name: name,
        platform: 'web',
        version: version
      },
      device: {
        browser: {
          name: a.browser.name,
          version: a.browser.version
        },
        os: {
          name: a.os.name,
          version: a.os.version
        },
        type: a.device.type ? a.device.type : 'computer'
      }
    }
  }
  toString () {
    return JSON.stringify(this._v)
  }
  browserName () {
    return this._v.device.browser.name
  }
  deviceType () {
    return this._v.device.type
  }
}

export default Agent
